// Centralized API configuration for local development & Vercel deployment.
// If API_BASE_URL (or REACT_APP_API_URL) is set in client/.env or Vercel Environment Variables,
// it uses that URL. Otherwise it defaults to http://localhost:3333.

export const API_BASE_URL = (
  process.env.API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:3333"
).replace(/\/+$/, "");
